export const ACTIVE_GLOBAL_SEARCH_KEY = '/';
